import { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet';
import ApplicationLayout from '../../../layouts/ApplicationLayout';
import TapIcon from '../../../services/TapIcon';
import { useSelector } from 'react-redux';
import HttpAPICall from '../../../services/HttpAPICall';
import Loader from '../../../components/ui/Loader/Loader';
import { toast } from 'react-toastify';
import { BACKOFFICE_BASE_URL } from '../../../services/TapApiUrls';

const AddManufacturer = ({ history, location }) => {
    const access_token = useSelector(state => state.auth.access_token);
    const [submitLoading, setSubmitLoading] = useState(false)
    const [formData, setFormData] = useState({
        id: "",
        name: "",
        notes: ""
    })
    const [isEditMode, setIsEditMode] = useState(false)

    const backToListing = () => {
        history.push({ pathname: '/manufacturer' });

    }
    useEffect(() => {
        initialFormData()
    }, []);

    const initialFormData = () => {
        if (location?.state?.editManufacturerData) {
            setFormData({
                id: location.state.editManufacturerData.id || "",
                name: location.state.editManufacturerData.name || "",
                notes: location.state.editManufacturerData.notes || ""
            })
            setIsEditMode(true)
        }
    }
    const submitDataForm = (e) => {
        e.preventDefault();

        setSubmitLoading(true)
        if (isEditMode == true) {
            HttpAPICall.withAthorization('PUT', BACKOFFICE_BASE_URL + '/iot_manufacturer_edit', access_token, {}, formData, (resp) => {
                toast.success(resp.data.msg, { position: toast.POSITION.TOP_RIGHT });
                history.push({ pathname: '/manufacturer', state: { id: formData.id } });
            }).then(() => setSubmitLoading(false));
        } else {
            HttpAPICall.withAthorization('POST', BACKOFFICE_BASE_URL + '/iot_manufacturer_add', access_token, {}, formData, (resp) => {
                toast.success(resp.data.msg, { position: toast.POSITION.TOP_RIGHT });
                backToListing();
            }).then(() => setSubmitLoading(false))
        }
    }
    const formInputHandler = (e) => {
        setFormData(pre => ({ ...pre, [e.target.name]: e.target.value }));
    };

    const formDatajsx = () => {
        return (
            <>
                <form className="bg-white p-3" onSubmit={submitDataForm} id="saveResourceForm">
                    <div className="row align-items-center my-3">
                        <div className="col-sm-3">
                            <label htmlFor="path" className="form-label require">Manufacturer</label>
                        </div>
                        <div className="col-sm-8 ">
                            <input
                                name="name"
                                type="text"
                                value={formData.name}
                                className="form-control"
                                autoComplete="off"
                                required={true}
                                onChange={formInputHandler}
                                placeholder="Please enter Manufacturer Name"

                            />
                        </div>
                    </div>
                    <div className="row align-items-center my-3">
                        <div className="col-sm-3">
                            <label htmlFor="path" className="form-label require">Notes</label>
                        </div>
                        <div className="col-sm-8 ">
                            <input
                                name="notes"
                                type="text"
                                value={formData.notes}
                                className="form-control"
                                autoComplete="off"
                                required={true}
                                onChange={formInputHandler}
                                placeholder="Please enter notes"

                            />
                        </div>
                    </div>
                    <div className="col-12 text-end fixed_footer">
                        <button type="button" className="btn btn-secondary mx-3" onClick={backToListing} disabled={submitLoading}>Cancel</button>
                        <button type="submit" className="btn btn-primary mx-2" disabled={submitLoading}>
                            Save {submitLoading ? (<TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin" />) : ''}
                        </button>
                    </div>
                </form>
            </>
        );
    };
    const addManufacturerJsx = () => {
        return (
            <>
                <div className="page_title row m0">
                    <div className="col-12">
                        <h3> {isEditMode ? "Edit " : "Add "} Manufacturer</h3>
                        <div className="text-end mt15">
                            <>
                                <button type="button" className="btn btn-secondary" onClick={backToListing}>
                                    <TapIcon.imageIcon icon={TapIcon.CloseIcon} className="img-fluid" alt="item-action" />
                                </button>
                            </>
                        </div>
                    </div>
                </div>
                <div className="container-fluid pl5">
                    <div className="page_containt row">
                        <div className={['pageTbl', 'col-12'].join(' ')}>{formDatajsx()}</div>
                    </div>
                </div>
            </>
        );
    };
    return (
        <ApplicationLayout>
            <Helmet><title>Add Device</title></Helmet>
            {addManufacturerJsx()}
        </ApplicationLayout>
    );
};

export default AddManufacturer;